import { consultationSteps } from '../../assets/consultationOptions';

export function StepProgress({ currentStep }) {
  return (
    <ol className="booking-progress" aria-label="Consultation booking progress">
      {consultationSteps.map((step) => {
        const state =
          currentStep > step.id ? 'is-complete' : currentStep === step.id ? 'is-current' : '';

        return (
          <li key={step.id} className={`booking-progress__item ${state}`.trim()}>
            <span className="booking-progress__index" aria-hidden="true">
              {step.id}
            </span>
            <span className="booking-progress__label">{step.label}</span>
          </li>
        );
      })}
    </ol>
  );
}
